import React, { useState } from "react";
import { icons } from "../../images";
import ConfirmationModal from "../Modal/ConfirmationModal";
import Button from "../Button/Button";

const DeleteRecipientOption = ({ onConfirm }) => {
  const [showWarning, setShowWarning] = useState(false);

  function handleConfirm() {
    setShowWarning(false);
    onConfirm();
  }

  return (
    <>
      <button type="button" className="tw-bg-transparent tw-group">
        <img
          className="tw-h-6 tw-opacity-70 group-hover:tw-opacity-100"
          src={icons.remove}
          alt="Delete"
          onClick={() => setShowWarning(true)}
        />
      </button>

      <ConfirmationModal
        title="Delete Recipient"
        brand="danger"
        size="md"
        show={showWarning}
        onClose={() => setShowWarning(false)}
      >
        <p>Do you want to delete this recipient?</p>
        <div className="tw-flex tw-gap-2 tw-mt-6">
          <Button
            type="button"
            brand="danger"
            fullwidth="true"
            onClick={handleConfirm}
          >
            Yes
          </Button>
          <Button
            brand="secondary"
            fullwidth="true"
            onClick={() => setShowWarning(false)}
          >
            No
          </Button>
        </div>
      </ConfirmationModal>
    </>
  );
};

export default DeleteRecipientOption;
